export const APP_NAME = 'Assembly';
export const THIS_IS_PREMIUM_FEATURE = 'This is a premium feature';
export const ENTIRE_ORGANIZATION = 'Entire organization';
